import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'resumes_count'
const DEFAULT_COUNT = 3

export const getCachedResumesCount = () => getCachedSkeletonCount(KEY, DEFAULT_COUNT)
export const setCachedResumesCount = (count) => setCachedSkeletonCount(KEY, count)
